import type {PropertyMap} from "../../common/utils/objects";
import type {Nullable} from "../../bootstrap/common/types";
import {PRESS_ICON, SOCIAL_ICON_FACEBOOK, SOCIAL_ICON_INSTAGRAM, SOCIAL_ICON_LINKEDIN, SOCIAL_ICON_TWITTER, SOCIAL_ICON_YOUTUBE} from "../../common/svgIcons";

export const CONFIRMABLE_CHANNELS: string[] = [
    "youtube"
];

export const TAG_LIMIT = 3;

export const ICONS: PropertyMap = {
    facebook: SOCIAL_ICON_FACEBOOK,
    twitter: SOCIAL_ICON_TWITTER,
    linkedin: SOCIAL_ICON_LINKEDIN,
    instagram: SOCIAL_ICON_INSTAGRAM,
    youtube: SOCIAL_ICON_YOUTUBE,
    press: PRESS_ICON
};

export type FeedChannel = {
    width?: FeedChannelWidth;
}

export type FeedChannelWidth = "small" | "large" | "double";

export function simpleFeedChannelMap(channels: Nullable<string[]>): PropertyMap<FeedChannel> {
    const channelMap: PropertyMap<FeedChannel> = {};
    channels?.forEach(channel => {
        channelMap[channel] = {};
    });
    return channelMap;
}